export const SET_JOB_FILTER = 'SET_JOB_FILTER';
export const SET_BULK_JOB_FILTER = 'SET_BULK_JOB_FILTER';
export const RESET_JOB_FILTER = 'RESET_JOB_FILTER';
export const IS_FILTER_IS_RESET = 'IS_FILTER_IS_RESET';
